$(document).ready(function() {

	var d = $('#berichten-wrapper');
	
	if (d.length) {
		setTimeout(function() {
			$('#berichten-wrapper').addClass('show');
		}, 300);

		d.animate({
			scrollTop: d.prop('scrollHeight')
		}, 0);
	}

})


// WEBPACK FOOTER //
// ./resources/js/berichten_scroll_to_bottom.js